import { LogOutIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogTitle } from '@sib/ui';
import { useDialog } from '../hooks';

interface LogoutButtonProps {
  onLogout: () => void;
}

export const LogoutButton = ({ onLogout }: LogoutButtonProps) => {
  const { isOpen, handleClose, handleOpen } = useDialog();
  const { t } = useTranslation();

  return (
    <>
      <Button
        onClick={handleOpen}
        variant="ghost"
        className="text-primary flex w-full justify-start"
      >
        <LogOutIcon className="size-[18px]" />
        {t('components.defaultLayout.logout')}
      </Button>

      <Dialog open={isOpen} onOpenChange={handleClose}>
        <DialogContent className="flex flex-col items-center">
          <DialogTitle className="text-xl">
            {t('components.defaultLayout.logout')}
          </DialogTitle>
          <p className="text-center text-sm">
            {t('components.defaultLayout.logOutConfirmation')}
          </p>
          <div className="mt-4 flex w-full justify-center gap-2">
            <Button
              onClick={() => {
                onLogout();
                handleClose();
              }}
              className="w-full max-w-48"
            >
              {t('components.defaultLayout.logout')}
            </Button>
            <Button
              onClick={handleClose}
              variant="outline"
              className="w-full max-w-48"
            >
              {t('cancel')}
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
